declare global {
  interface Window {
    dataLayer: any;
    ga: any;
  }
}

function trackEvent({
  event,
  section,
  link,
}: {
  event: string;
  section: string;
  link: string;
}) {
  if (window.ga) {
    window.ga('send', 'event', event, section, link);
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    click_section: section,
    click_link: link,
  });
}

export function trackAnalyticsEvent(event: MouseEvent) {
  const target = event.currentTarget as HTMLElement;
  if (!target) return;

  const category = target.getAttribute('data-category');
  const section = target.getAttribute('data-section');
  const link = target.getAttribute('data-link');
  trackEvent({
    event: category ?? 'meganav',
    section,
    link,
  });
}
